import { useState, useEffect } from 'react';

export function useMobileView() {
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const checkMobileView = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      setIsMobileView(width <= height);
    };

    // Initial check
    checkMobileView();

    // Event listener
    window.addEventListener('resize', checkMobileView);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobileView);
  }, []);

  return isMobileView;
}
